// Capitalize first character of a string
export const ucFirst = string =>
  string.charAt(0).toUpperCase() + string.slice(1);
